<div class="flex min-w-0 flex-1 flex-col">
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [rowClickable]="rowClickable()"
      [hideSearch]="hideSearch()"
      [searchPlaceHolder]="searchPlaceHolder()"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold! text-indigo-11!"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('property') {
                <td mat-cell *matCellDef="let app" class="py-4">
                  @let property = getProperty(app);
                  @if (property) {
                    <div class="flex items-center gap-4 cursor-pointer" [etxePropertyHoverPreview]="property">
                      <div
                        class="h-16 w-16 overflow-hidden rounded-lg bg-neutral-2 shadow-sm border border-neutral-6 shrink-0"
                      >
                        @let coverUrl = getCoverPhotoUrl(app);
                        @if (coverUrl) {
                          <img
                            [src]="coverUrl"
                            alt="Photo de couverture"
                            class="h-full w-full object-cover"
                          />
                        } @else {
                          <div class="flex h-full w-full items-center justify-center text-neutral-9">
                            <mat-icon>home</mat-icon>
                          </div>
                        }
                      </div>
                      <div class="flex flex-col min-w-0">
                        <span class="font-medium text-neutral-12 truncate">{{
                          property.presentation?.title || 'Bien sans titre'
                        }}</span>
                        <div class="flex items-center gap-2 text-xs text-neutral-10 mt-0.5">
                          @if (property.location?.address?.city; as city) {
                            <span>{{ city }}</span>
                          }
                          @if (property.definition?.reference; as ref) {
                            <span class="font-mono text-neutral-9">#{{ ref }}</span>
                          }
                        </div>
                      </div>
                    </div>
                  } @else {
                    <span class="italic text-xs text-neutral-9">Bien lié : {{ app.property }}</span>
                  }
                </td>
              }

              @case ('owner') {
                <td mat-cell *matCellDef="let app">
                  @let owner = getOwner(app);
                  @if (owner?.identity; as identity) {
                    @if (hasAppointmentOccurred(app)) {
                      <!-- Rendez-vous déjà eu lieu : avatar + prénom + nom complet -->
                      <div class="flex items-center gap-2.5">
                        <aura-avatar
                          [srcImage]="identity.avatar?.url"
                          [label]="identity.firstName"
                          [size]="'s'"
                        />
                        <div class="flex flex-col min-w-0">
                          <span class="font-medium text-neutral-12 text-sm truncate">
                            {{ identity.firstName | titlecase }} {{ identity.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                    } @else {
                      <!-- Candidature simple / Rendez-vous non effectué : prénom + 1ère lettre du nom (Jean M.) -->
                      <div class="flex items-center gap-2">
                        <div
                          class="h-7 w-7 rounded-full bg-neutral-3 text-neutral-11 border border-neutral-6 flex items-center justify-center text-xs font-semibold shrink-0"
                        >
                          {{ identity.firstName?.[0] | uppercase }}
                        </div>
                        <span class="font-medium text-neutral-12 text-sm">
                          {{ getMaskedOwnerName(identity) }}
                        </span>
                      </div>
                    }
                  } @else {
                    <span class="italic text-xs text-neutral-8">-</span>
                  }
                </td>
              }

              @case ('status') {
                <td mat-cell *matCellDef="let app">
                  @switch (app.status) {
                    @case ('accepted') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-jade-3 text-jade-11 border border-jade-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-jade-9"></span>
                        Mandat accordé
                      </div>
                    }
                    @case ('pending') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-blue-3 text-blue-11 border border-blue-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-blue-9"></span>
                        Candidature en cours
                      </div>
                    }
                    @case ('visit_invited') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-purple-3 text-purple-11 border border-purple-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-purple-9"></span>
                        Invitation à visiter
                      </div>
                    }
                    @case ('visit_confirmed') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-3 text-indigo-11 border border-indigo-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-indigo-9"></span>
                        Visite confirmée
                      </div>
                    }
                    @case ('visited') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-purple-3 text-purple-11 border border-purple-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-purple-9"></span>
                        Bien visité
                      </div>
                    }
                    @case ('offer_submitted') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-3 text-amber-11 border border-amber-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-amber-9"></span>
                        Offre définitive transmise
                      </div>
                    }
                    @case ('rejected') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-ruby-3 text-ruby-11 border border-ruby-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-ruby-9"></span>
                        Non retenue
                      </div>
                    }
                    @case ('cancelled') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-neutral-3 text-neutral-11 border border-neutral-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-neutral-9"></span>
                        Annulée
                      </div>
                    }
                    @case ('expired') {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-neutral-3 text-neutral-11 border border-neutral-6"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-neutral-9"></span>
                        Expirée
                      </div>
                    }
                    @default {
                      <div
                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-neutral-3 text-neutral-11 border border-neutral-6"
                      >
                        {{ app.status }}
                      </div>
                    }
                  }
                </td>
              }

              @case ('engagement.commissionRate') {
                <td mat-cell *matCellDef="let app">
                  <div class="flex flex-col">
                    <span class="font-medium text-neutral-12"> {{ app.engagement?.commissionRate }} % </span>
                    @let commEuros = getEstimatedCommissionEuros(app);
                    @if (commEuros) {
                      <span class="text-xs text-neutral-10"> Env. {{ commEuros | number }} € </span>
                    }
                  </div>
                </td>
              }

              @case ('financials.sellingPrice') {
                <td mat-cell *matCellDef="let app">
                  @let price = getSellingPriceEuros(app);
                  @if (price) {
                    <span class="font-medium text-neutral-12"> {{ price | number }} € </span>
                  } @else {
                    <span class="text-xs text-neutral-8 italic">-</span>
                  }
                </td>
              }

              @case ('pendingAction') {
                <td mat-cell *matCellDef="let app">
                  @if (app.pendingAction; as pa) {
                    <div
                      class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-amber-3 text-amber-11 border border-amber-6"
                    >
                      <mat-icon class="text-sm! w-3.5! h-3.5!">schedule</mat-icon>
                      {{ getPendingActionLabel(pa.actionType) }}
                    </div>
                  } @else {
                    <span class="text-xs text-neutral-9">Aucune action requise</span>
                  }
                </td>
              }

              @case ('appointment') {
                <td mat-cell *matCellDef="let app">
                  @if (app.appointment) {
                    <div class="inline-flex items-center gap-1 text-xs text-neutral-11">
                      <mat-icon class="text-sm! w-4! h-4! text-indigo-9">event</mat-icon>
                      <span>Rendez-vous associé</span>
                    </div>
                  } @else {
                    <span class="text-xs text-neutral-8 italic">-</span>
                  }
                </td>
              }

              @case ('createdAt') {
                <td mat-cell *matCellDef="let app">
                  <span class="text-sm text-neutral-11">
                    {{ app.createdAt | luxonDate: 'humanize' }}
                  </span>
                </td>
              }

              @case ('updatedAt') {
                <td mat-cell *matCellDef="let app">
                  <span class="text-sm text-neutral-11">
                    {{ app.updatedAt | luxonDate: 'humanize' }}
                  </span>
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
